import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';

import { classNames } from '@/utils/classnames';

type Props = {
  className?: string;
};

export const LiquidityDeselectedAlert = ({ className }: Props) => {
  return (
    <div
      className={classNames(
        fontStyles({
          variant: 'LABEL_MD',
          class: ['bg-token-red-300', 'text-token-red-1300', 'py-4', 'px-4', 'block', 'rounded-md'],
        }),
        className,
      )}
    >
      <div className="flex justify-start">
        <AlertCircleIcon className="justify-center" />
        <span className="justify-center ml-2">
          Deselecting Liquidity Sources can lead to unfavourable prices or insufficient liquidity
        </span>
      </div>
    </div>
  );
};
